import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-support",
  "use": "icon-support-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-support\"><path d=\"M8 17.962V17.5A1.5 1.5 0 0 1 9.5 16h5a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 8 20.5v-.514A4.516 4.516 0 0 1 4 15.5v-1h2v1c0 1.212.858 2.225 2 2.462zM10 20h4v-2h-4v2zM20 9h1a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-3V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v11H3a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h1V6.5A4.5 4.5 0 0 1 8.5 2h7A4.5 4.5 0 0 1 20 6.5V9zm0 6h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1v4zM4 11H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1v-4z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-support.svg
// module id = 892
// module chunks = 74